import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Compose conditional class names, letting later Tailwind classes win. */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
